import React from 'react';

export default function LiveScoresInline(props) {
    const score = props.data;
    const totalScore = score.formattedScores.find(sc => sc.isTotalScore);
    const scoreStrings = [
        `${totalScore ? `${totalScore.s1} - ${totalScore.s2}` : ''}`,
        `${score.periodo ? ` | ${score.periodo}` : ''}`,
        `${score.currentMinute ? `(${score.currentMinute})` : ''}`
    ];

    return (
        <div className={"flex w-full truncate" + (props.className ? props.className : '')}>
            <div className="w-full flex flex-col h-fit items-start truncate">
                <div className="w-full overflow-hidden truncate text-xs">{scoreStrings.join(' ')}</div>
                <div className="grid grid-cols-2 gap-x-1">
                    {score.formattedScores.slice(1).map(score =>
                        <div key={score.p} className="flex items-center h-fit text-cs9">
                            <span className="font-bold text-xxs mr-1">{score.p}</span>
                            <span className="text-xxs">{`(${score.s1}-${score.s2})`}</span> 
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
